import { useStaticQuery } from "gatsby";
export var useLatestMagazine = function useLatestMagazine() {
    var _useStaticQuery = useStaticQuery("2783630820"), allDatoCmsMagazine = _useStaticQuery.allDatoCmsMagazine;
    return allDatoCmsMagazine.nodes && allDatoCmsMagazine.nodes.length > 0 ? allDatoCmsMagazine.nodes[0] : undefined;
};
